module.exports = __webpack_public_path__ + "static/media/drop-pin-location.23b06fe7.svg";